export default __webpack_public_path__ + "static/damaris_logo-b34f4ca17831d6292d18a25ac2eb9dbb.png";